import { Files } from './Files';
export class Transfer {
    constructor(transferParameters) {
        var _a, _b;
        this.filesProcessing = new Files();
        this.filesCompleted = new Files();
        this.files = new Files(transferParameters.files);
        if (transferParameters) {
            if ('dropboxId' in transferParameters) {
                this.dropboxId = transferParameters.dropboxId;
            }
            else {
                this.teamId = transferParameters.teamId;
                this.customUrl = transferParameters.customUrl;
            }
            this.language = transferParameters.language;
            this.availabilityDuration = transferParameters.availabilityDuration;
            this.title = transferParameters.title;
            this.delivery = transferParameters.delivery;
            if (transferParameters.customization) {
                this.customization = {};
                if (typeof ((_a = transferParameters === null || transferParameters === void 0 ? void 0 : transferParameters.customization) === null || _a === void 0 ? void 0 : _a.logo) === 'string') {
                    this.customization.logo = transferParameters.customization.logo;
                }
                if (typeof ((_b = transferParameters === null || transferParameters === void 0 ? void 0 : transferParameters.customization) === null || _b === void 0 ? void 0 : _b.background) === 'string') {
                    this.customization.background = transferParameters.customization.background;
                }
            }
            this.promotion = transferParameters.promotion;
            this.preview = transferParameters.preview;
            this.accessTracking = transferParameters.accessTracking;
            this.notification = transferParameters.notification;
            this.password = transferParameters.password;
            this.description = transferParameters.description;
        }
    }
    get size() {
        return this.files.size;
    }
    get filesNumber() {
        return this.files.length;
    }
    populateCreatedTransfer({ transfer }) {
        this.id = transfer.id;
        this.title = transfer.title;
        this.status = transfer.status;
        this.region = transfer.region;
        this.preview = transfer.preview;
        this.created = transfer.created;
        this.deleted = transfer.deleted;
        this.modified = transfer.modified;
        this.language = transfer.language;
        this.transferUrl = transfer.transferUrl;
        this.uploadState = transfer.uploadState;
        this.description = transfer.description;
        this.promotion = transfer.promotion;
        this.customization = transfer.customization;
        this.parallelFiles = transfer.parallelFiles;
        this.parallelMinParts = transfer.parallelMinParts;
        this.parallelMaxParts = transfer.parallelMaxParts;
        this.parallelConnections = transfer.parallelConnections;
        this.availabilityEndDate = transfer.availabilityEndDate;
        this.availabilityDuration = transfer.availabilityDuration;
        this.availabilityStartDate = transfer.availabilityStartDate;
        this.delivery = transfer.delivery;
        this.queue = transfer.queue;
        this.queuedUntil = transfer.queuedUntil;
        if ('dropbox' in transfer) {
            this.dropboxId = transfer.dropbox;
        }
        return this;
    }
    populateUpdatedTransfer({ transfer }) {
        this.title = transfer.title;
        this.status = transfer.status;
        this.region = transfer.region;
        this.created = transfer.created;
        this.deleted = transfer.deleted;
        this.modified = transfer.modified;
        this.language = transfer.language;
        this.transferUrl = transfer.transferUrl;
        this.uploadState = transfer.uploadState;
        this.description = transfer.description;
        this.promotion = transfer.promotion;
        this.customization = transfer.customization;
        this.availabilityEndDate = transfer.availabilityEndDate;
        this.availabilityDuration = transfer.availabilityDuration;
        this.availabilityStartDate = transfer.availabilityStartDate;
        this.delivery = transfer.delivery;
        this.queue = transfer.queue;
        this.queuedUntil = transfer.queuedUntil;
        return this;
    }
    populateCreatedFile(fileToCreate, { file }) {
        fileToCreate.populateCreatedFile({ file });
        this.filesProcessing.add(fileToCreate);
        return fileToCreate;
    }
    populateCreatedParts(fileToUpdate, partsToCreate, { parts }) {
        const createdParts = fileToUpdate.populateCreatedParts(partsToCreate, { parts });
        return createdParts;
    }
    populateUploadedPart(fileToUpdate, partToUpdate, { part }) {
        fileToUpdate.populateUploadedPart(partToUpdate, { part });
        return partToUpdate;
    }
    populateCompletedParts(fileToUpdate, partsToComplete, { parts }) {
        fileToUpdate.populateCompletedParts(partsToComplete, { parts });
        return partsToComplete;
    }
    populateCompletedFile(fileToUpdate, { file }) {
        this.filesCompleted.add(fileToUpdate);
        this.filesProcessing.remove(fileToUpdate.name);
        fileToUpdate.populateCompletedFile({ file });
        return fileToUpdate;
    }
    populateLockedTransfer({ transfer }) {
        this.id = transfer.id;
        this.title = transfer.title;
        this.status = transfer.status;
        this.region = transfer.region;
        this.domain = transfer.domain;
        this.preview = transfer.preview;
        this.created = transfer.created;
        this.deleted = transfer.deleted;
        this.modified = transfer.modified;
        this.language = transfer.language;
        this.transferUrl = transfer.transferUrl;
        this.uploadState = transfer.uploadState;
        this.description = transfer.description;
        this.availabilityEndDate = transfer.availabilityEndDate;
        this.availabilityDuration = transfer.availabilityDuration;
        this.availabilityStartDate = transfer.availabilityStartDate;
        this.delivery = transfer.delivery;
        return this;
    }
    hasAllFilesUploaded() {
        return this.filesCompleted.length === this.filesNumber;
    }
    numberOfProcessingFiles() {
        return this.filesProcessing.length;
    }
    numberOfProcessingParts() {
        return this.filesProcessing.list().reduce((prev, curr) => prev + curr.partsToUpload.length, 0);
    }
    isFileUploaded(file) {
        return this.filesCompleted.has(file.name);
    }
}
